import React, { FC, ReactElement } from 'react'
import styles from './Body.module.css'
import classNames from 'classnames'

const Body: FC<{
	children: React.ReactNode
	className?: string
}> = (props): ReactElement => {
	return (
		<div
			className={classNames(styles.root, {
				[(props.className as any)]: !!props.className
			})}
		>
			{props.children}
		</div>
	)
}

export default Body
